import { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'it');

  useEffect(() => {
    localStorage.setItem('lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (section, key) => {
    const entry = translations[section]?.[key];
    if (!entry) return key;
    return entry[lang] || entry['it'] || key;
  };

  const toggleLang = () => setLang(lang === 'it' ? 'en' : 'it');

  const serviceName = (name) => {
    if (lang === 'en' && translations.serviceNamesEN[name]) {
      return translations.serviceNamesEN[name];
    }
    return name;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, serviceName }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
